<template>
    <div class="_tag">
        <el-scrollbar style="margin-right: 6px;">
            <div class="left">
                <el-tag
                        v-for="tag in tagsList"
                        :key="tag.title"
                        :closable="!tag.hideclose"
                        :type="isActive(tag)"
                        @close="handleCloseTag(tag)"
                >
                    <router-link :to="tag.path" class="tag-title" >{{
                        tag.title
                        }}
                    </router-link>

                </el-tag>
            </div>
        </el-scrollbar>

        <el-dropdown @command="handleCloseBtn">
      <span class="el-dropdown-link">
        <i class="el-icon-menu"></i>
      </span>
            <template #dropdown>
                <el-dropdown-menu>
                    <el-dropdown-item
                            icon="el-icon-circle-close"
                            command="closeOther"
                            class="el-button-menu"
                    >关闭其它
                    </el-dropdown-item
                    >
                    <el-dropdown-item
                            icon="el-icon-close"
                            command="closeAll"
                            class="el-button-menu"
                    >关闭全部
                    </el-dropdown-item
                    >
                </el-dropdown-menu>
            </template>
        </el-dropdown>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tagsList: [],
            };
        },
        mounted() {
            if (this.tagsList.length == 0) {
                if (this.$store.state.tabs.visitedTab.length > 0) {
                    this.tagsList = this.$store.state.tabs.visitedTab;
                }
            }
            this.setTags(this.$route);
        },
        methods: {
            setTags(route) {
                //设置标签
                const isExsit = this.tagsList.some((item) => {
                    return item.path === route.fullPath;
                });
                // tab_title 如果是跳转页面，且传入了参数tab_title，则选项卡名称为tab_title值，
                var tab_title_value = route.meta.title; //默认名称
                if (route.query.tab_title) {
                    tab_title_value = route.query.tab_title
                }
                if (isExsit == false) {
                    this.tagsList.push({
                        //标签名
                        // title: route.meta.title,
                        title: tab_title_value,
                        //路由里的name对应vue页的name,标签列表里的name可以做vue页面缓存
                        name: route.name,
                        //路由
                        path: route.fullPath,
                        //是否隐藏关闭
                        hideclose: route.meta.hideclose ? route.meta.hideclose : false,
                    });
                }
            },
            handleCloseTag(tag) {
                console.log("count:" + this.tagsList.length);
                //关闭标签
                this.tagsList.splice(this.tagsList.indexOf(tag), 1);
                // array.splice(index,howmany) 从索引为index处删除howmany个元素
                if (this.tagsList.length > 0) {
                    this.$router.push(this.tagsList[this.tagsList.length - 1].path);
                } else {
                    this.$router.push("/index");
                    //this.$router.push({ name: "index" });
                }
            },
            handleCloseBtn(command) {
                //关闭功能按钮
                if (command == "closeOther") {
                    //关闭其它,保留没有删除的标签。find() 方法返回通过测试（函数内判断）的数组的第一个元素的值。
                    var activeTag = this.tagsList.find((item) => {
                        return item.path == this.$route.fullPath;
                    }); //查找第一个满足的
                    var noCloseTags = this.getNoCloseTabs();
                    if (
                        noCloseTags.some((item) => {
                            return item.path == activeTag.path && item.title == activeTag.title;
                        }) == false
                    ) {
                        //不包含
                        noCloseTags = noCloseTags.concat(activeTag);
                    }
                    this.tagsList = noCloseTags;
                } else if (command == "closeAll") {
                    //关闭所有,保留没有删除的标签
                    this.tagsList = this.getNoCloseTabs();
                    this.$router.push(this.tagsList[this.tagsList.length - 1].path);
                }
            },
            getNoCloseTabs() {
                //获取没有删除的标签
                var noCloseList = this.tagsList.filter((item) => {
                    return item.hideclose == true;
                });
                return noCloseList;
            },
            isActive(tag) {
                console.log("========isActive===begin1=====")
                console.log(tag);
                console.log(this.$route);

                //是否选中
                if (tag.title == this.$route.query.tab_title) {

                    console.log("========isActive===end1=====")
                    return "";
                } else {
                    console.log("info");
                    console.log("========isActive===end2=====")
                    return "info";
                }

                //是否选中
                // if (tag.path == this.$route.fullPath) {
                //     return "";
                // } else {
                //     return "info";
                // }
            },


            // 找到已经打开的相同选项卡，并关闭
            // getSameTab(open_name,now_tagsList) {
            //     console.log("================")
            //     console.log(open_name)
            //     console.log(now_tagsList)
            //     console.log("================")
            //
            //     // 循环匹配已打开的相同选项卡
            //     for (let i = 0; i < now_tagsList.length; i++) {
            //         console.log("======0==========")
            //         console.log(now_tagsList.length)
            //         console.log(now_tagsList)
            //         console.log(now_tagsList[i])
            //         console.log(open_name)
            //         console.log("======0==========")
            //         if (now_tagsList[i]['name'] == 'Index') {
            //             continue
            //         }
            //         if (now_tagsList[i]['name'] == open_name) {
            //             console.log("======1==========")
            //             console.log(now_tagsList[i]['name'])
            //             console.log(open_name)
            //             console.log(now_tagsList[i])
            //             console.log("======1==========")
            //             this.handleCloseTag(now_tagsList[i]);
            //         }
            //     }
            //
            // }


        },
        watch: {

            $route(newValue, oldValue) {
                // 监听路由变化,设置标签
                // this.getSameTab(newValue.name, this.tagsList)
                this.setTags(newValue);

                if (this.tagsList.length != 0) {
                    this.$store.dispatch("setVisitedTab", this.tagsList);
                }

                //console.log("-------setVisitedTab1------");
            },
            deep: true,
        },
    };
</script>

<style lang="scss" scoped>
    ._tag {
        // border: 1px solid green;
        flex: 0 0 40px;
        display: flex;
        align-items: center;
        background-color: white;
        border-bottom: 1px solid #d8dce5;
        justify-content: space-between;
        //box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
        .left {
            display: flex;
            height: 30px;
            align-items: center;

            .el-tag {
                margin-left: 0px;
                height: 30px;
                border-radius: 0;
                line-height: 27px;
                background-color: #fff;
                border-color: #e6e6e6;
                border-left: none;
                border-bottom: none;

                .tag-title {
                    color: black;
                    padding: 8px 2px;
                    text-align: center;
                    text-decoration: none;
                }

                .router-link-active {
                    color: #409eff;
                }

                // router-link-active router-link-exact-active tag-title
            }
        }

        ._dropdown {
            height: 30px;
            display: flex;
            align-items: center;
            background-color: white;
            box-shadow: rgba(0, 0, 0, 0.1) -3px 0px 15px 3px;
            padding: 0 5px;
        }
    }

    .el-dropdown-link {
        height: 29px;
        display: flex;
        align-items: center;
        padding-left: 0.4rem;
        padding-right: 0.4rem;
        font-size: 0.3rem;
    }

    .el-dropdown-link:hover {
        background-color: rgba(246, 246, 246, 1);
    }

    .el-dropdown-link img {
        width: 0.5rem;
        margin-right: 0.125rem;
    }

    .el-dropdown-link i {
        margin-left: 0.125rem;
    }

    .el-dropdown-menu： {
        margin-right: 0;
    }

    .el-button-menu:hover {
        background-color: rgba(246, 246, 246, 1);
        color: #000;
    }
</style>
